import {Event as EventType} from "@/enums/Event";

import {EventInterface} from "@/types/Event";
import {LocationInterface} from "@/types/Location";
import {TicketCategoryInterface} from "@/types/TicketCategory";

import {Promoter} from "@/util/Promoter";
import {Location} from "@/util/Location";
import {TicketCategory} from "@/util/TicketCategory";


export class Event implements EventInterface {
  id!: number;
  flyer?: string;
  locations!: Location[];
  name!: string;
  promoter!: Promoter;
  shortDescription?: string;
  ticketCategories!: TicketCategory[];
  selectedLocation?: Location;
  photoUrl?: string;

  constructor({id, flyer, locations, name, promoter, shortDescription, ticketCategories, photoUrl}: EventInterface) {
    this.id = id;
    this.flyer = flyer;
    this.photoUrl = photoUrl;
    this.shortDescription = shortDescription;
    if (!Array.isArray(locations)) {
      locations = [locations];
    }
    this.locations = locations.map((location: LocationInterface) => {
      return new Location(location)
    });
    this.name = name;
    this.promoter = new Promoter(promoter);
    if (!Array.isArray(ticketCategories)) {
      ticketCategories = [ticketCategories];
    }
    this.ticketCategories = ticketCategories.map((ticketCategory: TicketCategoryInterface) => {
      return new TicketCategory(ticketCategory)
    });
  }

  get maxPrice(): number {
    const prices: number[] = this.prices;

    return Math.max(...prices)
  }

  get price(): (ticketCategoryId: number) => number | undefined {
    return (ticketCategoryId: number) => {
      const ticketCategory = this.ticketCategories.find(
        (ticketCategory: TicketCategory) => {
          return ticketCategory.entityId === ticketCategoryId
        }
      );

      if (!ticketCategory) {
        return undefined;
      }

      return ticketCategory.price
    }
  }

  private get prices(): number[] {
    const prices: number[] = this.ticketCategories.map(
      (ticketCategory: TicketCategory) => {
        return ticketCategory.price
      }
    );

    return prices
  }

  get type(): EventType {
    if(!Array.isArray(this.locations)) {
      return EventType.LIVE
    }

    if(this.locations.length == 1) {
      return EventType.LIVE
    }

    return EventType.LIVESTREAM
  }

  get ticketCategory() {
    return (id:number | string) => {
      const ticketCategory = this.ticketCategories.find((ticketCategory:TicketCategory) => {
        return ticketCategory.entityId == id;
      });

      return ticketCategory;
    }
  }
}
